import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { setupManagementUrl } from "../../../../config";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { allInsightType } from "../../../../data/Queries/SetupManagement/FinSightsQueries";
import DynamicForm from "../../../../data/Axios/DynamicForm"

const base_url = setupManagementUrl.uri;

const PayBillsForm = (props) => {
  const [insightData, setInsightData] = useState([]);

  const initialValues = {
    id: props.data ? props.data.id : "",
    paybill: props.data ? props.data.paybill : "",
    name: props.data ? props.data.name : "",
    insightTypeId: props.data ? props.data.insightTypeId : "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { paybill, name, insightTypeId } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            paybill,
            name,
            insightTypeId,
          }
        : {
            paybill,
            name,
            insightTypeId,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updatePaybills" : "createPaybills",
        mutationData,
        "paybill",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `PayBill ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const insightResponse = await graphqlQuery(allInsightType, base_url);

        if (insightResponse) {
          setInsightData(insightResponse || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchAllData();
  }, []);

  const insightTypeOptions = insightData
    ? insightData.map((data) => ({
        value: data.id,
        label: data.description,
      }))
    : [];

  const fields = [
    {
      name: "paybill",
      label: "PayBill *",
      type: "number",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "name",
      label: "Name *",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "insightTypeId",
      label: "Insight Type*",
      type: "select",
      options: insightTypeOptions,
      gridColumn: "span 2",
      required: true,
    },
  ];

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit PayBill" : "Create PayBill"}
      subtitle={
        props.isEditing ? "Edit an Existing PayBill" : "Create a New PayBill"
      }
    />
  );
};

export default PayBillsForm;
